import React, { useState, useContext, useEffect } from "react";
import { GOOGLE_CLOUD_API_KEY } from "../../../../utils/generalData";
import { ManageLoadPostDetailPageContext } from "../";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

const RouteMap = () => {
  const google = window.google;
  const [map, setMap] = useState();
  const [mapRef, setMapRef] = useState(undefined);

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [loadPostDetailState] = useContext(ManageLoadPostDetailPageContext);
  const loadPostDetail = loadPostDetailState.loadPostDetail;

  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  const render = (status) => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
  };

  useEffect(() => {
    // init map
    if (mapRef && !map) {
      setMap(
        new google.maps.Map(mapRef, {
          center: {
            lat: 25.328624,
            lng: 89.532854,
          },
          zoom: 10,
        })
      );

      setDirectionsService(new google.maps.DirectionsService());
      setDirectionsRenderer(new google.maps.DirectionsRenderer());
    }
  }, [mapRef, google, map]);

  useEffect(() => {
    if (map && loadPostDetail) {
      directionsRenderer.setMap(map);

      directionsService
        .route({
          origin: {
            lat: Number(loadPostDetail.origin_latitude),
            lng: Number(loadPostDetail.origin_longitude),
          },
          destination: {
            lat: Number(loadPostDetail.destination_latitude),
            lng: Number(loadPostDetail.destination_longitude),
          },
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((response) => {
          directionsRenderer.setDirections(response);
          setDirectionsResponse(response);
        })
        .catch((e) => {});
    }
  }, [map, loadPostDetail]);

  return (
    <section id="load-post-google-map">
      <div className="container theme-section">
        <h1>Closest Route From Origin To Destination</h1>

        <p>
          <b>From:</b> {directionsResponse?.routes[0]?.legs[0]?.start_address}
        </p>
        <p>
          <b>To</b>: {directionsResponse?.routes[0]?.legs[0]?.end_address}
        </p>
        <p>
          <b>Distance:</b> {" "}
          {directionsResponse?.routes[0]?.legs[0]?.distance?.text}
        </p>
        <p>
          <b>Estimated Time:</b>{" "}
          {directionsResponse?.routes[0]?.legs[0]?.duration?.text}
        </p>
        <br></br>

        <Wrapper apiKey={GOOGLE_CLOUD_API_KEY} render={render}>
          <div ref={setMapRef} style={{ width: "100%", height: "500px" }} />
        </Wrapper>
      </div>
    </section>
  );
};

export default React.memo(RouteMap);
